import {KEY} from './KEY';

export const DB_ID = KEY;
